<template>
	<div class="note-card">
		<h1>Greenbelt application complete!</h1>
		<p></p>
		<p>Your application for <strong>{{project_park_name}}</strong> has been submitted.</p>
		
		<hr>
		<div class="btn-container">
			<el-button type="primary" @click="viewPDF"><i class="el-icon-view"></i>View Completed Report</el-button>
			<el-button type="success" @click="startNewApp"><i class="el-icon-plus"></i>Start Another Application</el-button>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	created(){
		this.$emit('hide-navigation');
	},
	computed: {
		...mapState('application/project_information', ['project_park_name']),
	},
	methods: {
		startNewApp(){
			const site_path = process.env.VUE_APP_SITE_PATH  + '/funding-request';
			window.open(site_path);
		},
		viewPDF(){
			const pdf_path = `${process.env.VUE_APP_SITE_PATH}/report/${this.$store.state.route.params.application_hash}`;
			window.open(pdf_path);
		}
	}
}
</script>

<style lang="scss" scoped>
.note-card{
	text-align:center;
}
i{
	margin-right:7px;
	font-size:16px;
}
.btn-container{
	width:fit-content;
	margin:0 auto;
}
</style>
